import { render, staticRenderFns } from "./ContainerSubHeader.vue?vue&type=template&id=6ec2490d&scoped=true"
import script from "./ContainerSubHeader.vue?vue&type=script&lang=js"
export * from "./ContainerSubHeader.vue?vue&type=script&lang=js"
import style0 from "./ContainerSubHeader.css?vue&type=style&index=0&id=6ec2490d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec2490d",
  null
  
)

export default component.exports